<side-panel [stepData]="stepData">
    <ng-template let-rowDetail #contentSidePanel>
        <div class="configuration-fields" *ngIf="rowDetail.name=='Nome'">
            <div class="content">
                <form [formGroup]="form" nz-form nzLayout="vertical">
                    <nz-form-item>
                        <nz-form-label nzRequired>Título</nz-form-label>
                        <nz-form-control>
                            <input nz-input type="text" formControlName="title">
                        </nz-form-control>
                    </nz-form-item>
                    <nz-form-item>
                        <nz-form-label>Tempo de Atualização</nz-form-label>
                        <nz-form-control>
                            <input nz-input type="number" formControlName="refresh">
                        </nz-form-control>
                    </nz-form-item>
                </form>
            </div>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='query'">
            <query-executor [usePopup]="false" [query]="query" (queryChange)="onQueryChange($event)"
                [showObject]="false" [testMode]="true"></query-executor>
            <suspended-menu *ngIf="filters" title="Filtros" [show]="true" [data]="filters" dropprefix='{@'
                dropsufix='}' heigth="170"></suspended-menu>
        </div>
        <div class="configuration-fields" *ngIf="rowDetail.name=='advanced'">
            <button nz-button nzType="text" nzShape="circle" (click)="formatJSON()" class="float-menu-format"
                nz-tooltip nzTooltipTitle="Formatar JSON">
                <span nz-icon nzType="thunderbolt"></span>
            </button>
            <div class="avancado-detail">
                <nz-form-item class="avancado-detail__field">
                    <nz-form-label>Expressão</nz-form-label>
                    <nz-form-control class="avancado-detail__control">
                        <textarea nz-input
                            id="area-expression"
                            autocomplete="off"
                            placeholder="Expressão"
                            aria-label="Expressão"
                            (focus)="loadQuery()"
                            class="avancado-detail__textarea"
                            [formControl]="options" name="lo"></textarea>
                    </nz-form-control>
                </nz-form-item>
                <suspended-menu *ngIf="fields" title="Campos" [show]="true" [data]="fields" heigth="170"></suspended-menu>
            </div>
        </div>
    </ng-template>
</side-panel>
